"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_components_1 = require("@securityproducts/core-components");
var displayDataBy_styles_1 = require("./displayDataBy.styles");
var displayDataBy_i18n_1 = require("./displayDataBy.i18n");
function DisplayDataBy(props) {
    var hoursActive = props.current === "HOURS";
    var daysActive = props.current === "DAYS";
    var monthsActive = props.current === "MONTHS";
    var byHourClass = hoursActive ? displayDataBy_styles_1.timeSliceButtonActive : displayDataBy_styles_1.timeSliceButton;
    var byDayClass = daysActive ? displayDataBy_styles_1.timeSliceButtonActive : displayDataBy_styles_1.timeSliceButton;
    var byMonthClass = monthsActive ? displayDataBy_styles_1.timeSliceButtonActive : displayDataBy_styles_1.timeSliceButton;
    var strings = core_components_1.useLocalisation(displayDataBy_i18n_1.displayDataByTranslations, props.language);
    return (React.createElement(core_components_1.ButtonGroup, { fullWidth: true },
        React.createElement(core_components_1.Button, { className: byHourClass, "data-qa": hoursActive ? true : false, disabled: props.allowedActions.indexOf("HOURS") === -1, id: "display-report-by-hour", onClick: function () {
                props.setRange("HOURS");
            }, qa: "display", active: hoursActive }, strings.hour),
        React.createElement(core_components_1.Button, { className: byDayClass, "data-qa": daysActive ? true : false, disabled: props.allowedActions.indexOf("DAYS") === -1, id: "display-report-by-day", onClick: function () {
                props.setRange("DAYS");
                props.setReset(true);
            }, qa: "display", active: daysActive }, strings.day),
        React.createElement(core_components_1.Button, { className: byMonthClass, "data-qa": monthsActive ? true : false, disabled: props.allowedActions.indexOf("MONTHS") === -1, id: "display-report-by-month", onClick: function () {
                props.setRange("MONTHS");
                props.setReset(true);
            }, qa: "display", active: monthsActive }, strings.month)));
}
exports.DisplayDataBy = DisplayDataBy;
